const getOffer = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/Offer`, {
      method: "GET",
    });
   
    if (!response.ok) {
      console.error(`Error: ${response.status}`);
      return null;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Fetch error:", error);
    return null;
  }
};

export default getOffer;
